import {
  BatterPlayerReportResultDto,
  BatterReportChartConfigDto,
  BatterSessionReportChartConfigDto,
  BatterSessionReportResultDto,
  BatterSingleSessionReportChartConfigDto,
  BatterSingleSessionReportResultDto,
  ChartType,
  ExternalBatterReportChartConfigDto,
  ExternalBatterReportResultDto,
  ExternalPitcherReportChartConfigDto,
  ExternalPitcherReportResultDto,
  GraphChartConfigDto,
  HeatmapChartConfigDto,
  PercentileRankingsChartConfigDto,
  PitcherPlayerReportResultDto,
  PitcherReportChartConfigDto,
  PitcherSessionReportChartConfigDto,
  PitcherSessionReportResultDto,
  PitcherSingleSessionReportChartConfigDto,
  PitcherSingleSessionReportResultDto,
  PlayerStatChartConfigDto,
  PracticeBatterSessionReportChartConfigDto,
  PracticeBatterSessionReportResultDto,
  PracticeBatterSingleSessionReportChartConfigDto,
  PracticeBatterSingleSessionReportResultDto,
  PracticePitcherSessionReportChartConfigDto,
  PracticePitcherSessionReportResultDto,
  PracticePitcherSingleSessionReportChartConfigDto,
  PracticePitcherSingleSessionReportResultDto,
  SprayOrSprayZoneChartConfigDto,
  UmpireReportChartConfigDto,
  UmpireReportForAdminChartConfigDto,
  UmpireReportForAdminResultDto,
  UmpireReportForSessionChartConfigDto,
  UmpireReportForSessionResultDto,
  UmpireReportResultDto,
} from 'types/CodegenReportTypes';

import BatterApproachPerCountChart from 'components/ReportCharts/BatterApproachPerCountChart/BatterApproachPerCountChart';
import BatterBallStrikeSummaryChart from 'components/ReportCharts/BatterBallStrikeSummaryChart/BatterBallStrikeSummaryChart';
import BatterBallStrikeSummaryChartSidebar from 'components/ReportCharts/BatterBallStrikeSummaryChart/BatterBallStrikeSummaryChartSidebar';
import BatterBattingStatsChart from 'components/ReportCharts/BattingStatsChart/BattingStatsChart';
import BatterSessionStatsByPitchTypeChart from 'components/ReportCharts/BatterSessionStatsByPitchTypeChart/BatterSessionStatsByPitchTypeChart';
import BatterSessionStatsByPitchTypeChartSidebar from 'components/ReportCharts/BatterSessionStatsByPitchTypeChart/BatterSessionStatsByPitchTypeChartSidebar';
import BatterSingleSessionContactPointChart from 'components/ReportCharts/BatterSingleSessionContactPointChart/BatterSingleSessionContactPointChart';
import BatterSingleSessionPitchByPitchStatsChart from 'components/ReportCharts/BatterSingleSessionPitchByPitchStatsChart/BatterSingleSessionPitchByPitchStatsChart';
import BatterSingleSessionPitchLocationChart from 'components/ReportCharts/BatterSingleSessionPitchLocationChart/BatterSingleSessionPitchLocationChart';
import BatterSingleSessionGameStatsChart from 'components/ReportCharts/BatterSingleSessionGameStatsChart/BatterSingleSessionGameStatsChart';
import BatterSingleSessionGameStatsChartSidebar from 'components/ReportCharts/BatterSingleSessionGameStatsChart/BatterSingleSessionGameStatsChartSidebar';
import BatterSingleSessionPitchByPitchStatsChartSidebar from 'components/ReportCharts/BatterSingleSessionPitchByPitchStatsChart/BatterSingleSessionPitchByPitchStatsChartSidebar';
import BatterSingleSessionPitchLocationChartSidebar from 'components/ReportCharts/BatterSingleSessionPitchLocationChart/BatterSingleSessionPitchLocationChartSidebar';
import BatterUsedPitchTypesChart from 'components/ReportCharts/BatterUsedPitchTypesChart/BatterUsedPitchTypesChart';
import BatterUsedPitchTypesChartSidebar from 'components/ReportCharts/BatterUsedPitchTypesChart/BatterUsedPitchTypesChartSidebar';
import BattingStatsChartSidebar from 'components/ReportCharts/BattingStatsChart/BattingStatsChartSidebar';
import PitchesPerCountChart from 'components/ReportCharts/PitchesPerCountChart/PitchesPerCountChart';
import PitcherBallTrackingStatsChart from 'components/ReportCharts/PitcherBallTrackingStatsChart/PitcherBallTrackingStatsChart';
import PitcherBallTrackingStatsChartSidebar from 'components/ReportCharts/PitcherBallTrackingStatsChart/PitcherBallTrackingStatsChartSidebar';
import PitcherSessionPitchTypeRangesChart from 'components/ReportCharts/PitcherSessionPitchTypeRangesChart/PitcherSessionPitchTypeRangesChart';
import PitcherSessionStatsByPitchTypeChart from 'components/ReportCharts/PitcherSessionStatsByPitchTypeChart/PitcherSessionStatsByPitchTypeChart';
import PitcherSessionTiltChart from 'components/ReportCharts/PitcherSessionTiltChart/PitcherSessionTiltChart';
import ReportLineChart from 'components/ReportChartsShared/ReportLineChart/ReportLineChart';
import PitcherSessionStatsByPitchTypeChartSidebar from 'components/ReportCharts/PitcherSessionStatsByPitchTypeChart/PitcherSessionStatsByPitchTypeChartSidebar';
import PitcherSessionPitchTypeRangesChartSidebar from 'components/ReportCharts/PitcherSessionPitchTypeRangesChart/PitcherSessionPitchTypeRangesChartSidebar';
import ReportLineChartSidebar from 'components/ReportChartsShared/ReportLineChart/ReportLineChartSidebar';
import TimelineChart from 'components/ReportChartsShared/TimelineChart/TimelineChart';
import TimelineChartSidebar from 'components/ReportChartsShared/TimelineChart/TimelineChartSidebar';
import PitcherSessionPitchLocationChart from 'components/ReportCharts/PitcherSessionPitchLocationChart/PitcherSessionPitchLocationChart';
import PitcherSessionPitchLocationChartSidebar from 'components/ReportCharts/PitcherSessionPitchLocationChart/PitcherSessionPitchLocationChartSidebar';
import PitcherSingleSessionGameStatsChart from 'components/ReportCharts/PitcherSingleSessionGameStatsChart/PitcherSingleSessionGameStatsChart';
import PitcherSingleSessionPitchByPitchStatsChart from 'components/ReportCharts/PitcherSingleSessionPitchByPitchStatsChart/PitcherSingleSessionPitchByPitchStatsChart';
import PitcherSingleSessionPitchTypeRangesChart from 'components/ReportCharts/PitcherSingleSessionPitchTypeRangesChart/PitcherSingleSessionPitchTypeRangesChart';
import PitcherSingleSessionPitchTypeUsageChart from 'components/ReportCharts/PitcherSingleSessionPitchTypeUsageChart/PitcherSingleSessionPitchTypeUsageChart';
import PitcherSingleSessionStatsByPitchTypeChart from 'components/ReportCharts/PitcherSingleSessionStatsByPitchTypeChart/PitcherSingleSessionStatsByPitchTypeChart';
import PitcherSingleSessionGameStatsChartSidebar from 'components/ReportCharts/PitcherSingleSessionGameStatsChart/PitcherSingleSessionGameStatsChartSidebar';
import PitcherSingleSessionStatsByPitchTypeChartSidebar from 'components/ReportCharts/PitcherSingleSessionStatsByPitchTypeChart/PitcherSingleSessionStatsByPitchTypeChartSidebar';
import PitcherSingleSessionPitchByPitchStatsChartSidebar from 'components/ReportCharts/PitcherSingleSessionPitchByPitchStatsChart/PitcherSingleSessionPitchByPitchStatsChartSidebar';
import PitcherSingleSessionPitchTypeRangesChartSidebar from 'components/ReportCharts/PitcherSingleSessionPitchTypeRangesChart/PitcherSingleSessionPitchTypeRangesChartSidebar';
import PitcherSingleSessionPitchLocationChart from 'components/ReportCharts/PitcherSingleSessionPitchLocationChart/PitcherSingleSessionPitchLocationChart';
import PitcherSingleSessionPitchLocationChartSidebar from 'components/ReportCharts/PitcherSingleSessionPitchLocationChart/PitcherSingleSessionPitchLocationChartSidebar';
import PitchingStatsChart from 'components/ReportCharts/PitchingStatsChart/PitchingStatsChart';
import PitchingStatsChartSidebar from 'components/ReportCharts/PitchingStatsChart/PitchingStatsChartSidebar';
import PitchTypeStatsChart from 'components/ReportCharts/PitchTypeStatsChart/PitchTypeStatsChart';
import PitchTypeStatsChartSidebar from 'components/ReportCharts/PitchTypeStatsChart/PitchTypeStatsChartSidebar';
import UmpireGamePerformanceChart from 'components/ReportCharts/UmpireGamePerformanceChart/UmpireGamePerformanceChart';
import UmpirePitchCallChart from 'components/ReportCharts/UmpirePitchCallChart/UmpirePitchCallChart';
import UmpirePerformanceSummaryChart from 'components/ReportCharts/UmpirePerformanceSummaryChart/UmpirePerformanceSummaryChart';
import UmpireStrikeZoneAccuracyChart from 'components/ReportCharts/UmpireStrikeZoneAccuracyChart/UmpireStrikeZoneAccuracyChart';
import UmpireStrikeZoneChart from 'components/ReportCharts/UmpireStrikeZoneChart/UmpireStrikeZoneChart';
import UmpireTopAndBottomPerformanceChart from 'components/ReportCharts/UmpireTopAndBottomPerformanceChart/UmpireTopAndBottomPerformanceChart';
import UmpireTrendsChart from 'components/ReportCharts/UmpireTrendsChart/UmpireTrendsChart';
import UmpireStrikeZoneChartSidebar from 'components/ReportCharts/UmpireStrikeZoneChart/UmpireStrikeZoneChartSidebar';
import UmpirePitchCallChartSidebar from 'components/ReportCharts/UmpirePitchCallChart/UmpirePitchCallChartSidebar';
import UmpireGamePerformanceChartSidebar from 'components/ReportCharts/UmpireGamePerformanceChart/UmpireGamePerformanceChartSidebar';
import UmpirePerformanceSummaryChartSidebar from 'components/ReportCharts/UmpirePerformanceSummaryChart/UmpirePerformanceSummaryChartSidebar';
import UmpireTrendsChartSidebar from 'components/ReportCharts/UmpireTrendsChart/UmpireTrendsChartSidebar';
import UmpireTopAndBottomPerformanceChartSidebar from 'components/ReportCharts/UmpireTopAndBottomPerformanceChart/UmpireTopAndBottomPerformanceChartSidebar';
import ReportScatterChart from 'components/ReportChartsShared/ReportScatterChart/ReportScatterChart';
import ReportScatterChartSidebar from 'components/ReportChartsShared/ReportScatterChart/ReportScatterChartSidebar';
import {
  BatterStrikeZoneHeatmapChart,
  PitcherStrikeZoneHeatmapChart,
} from 'components/ReportChartsShared/StrikeZoneHeatmapChart/StrikeZoneHeatmapChart';
import StrikeZoneHeatmapChartSidebar from 'components/ReportChartsShared/StrikeZoneHeatmapChart/StrikeZoneHeatmapChartSidebar';
import SprayOrSprayZoneChart from 'components/ReportChartsShared/SprayOrSprayZoneChart/SprayOrSprayZoneChart';
import SprayOrSprayZoneChartSidebar from 'components/ReportChartsShared/SprayOrSprayZoneChart/SprayOrSprayZoneChartSidebar';
import PercentileRankingsChart from 'components/ReportChartsShared/PercentileRankingsChart/PercentileRankingsChart';
import PercentileRankingsChartSidebar from 'components/ReportChartsShared/PercentileRankingsChart/PercentileRankingsChartSidebar';
import BattingStatChart from 'components/ReportChartsShared/BattingStatChart/BattingStatChart';
import BattingStatChartSidebar from 'components/ReportChartsShared/BattingStatChart/BattingStatChartSidebar';
import PracticeBatterSingleSessionSummaryChart from 'components/ReportCharts/PracticeBatterSingleSessionSummaryChart/PracticeBatterSingleSessionSummaryChart';
import PracticeBatterSingleSessionSummaryChartSidebar from 'components/ReportCharts/PracticeBatterSingleSessionSummaryChart/PracticeBatterSingleSessionSummaryChartSidebar';
import PracticeBatterSingleSessionSummaryAggregatedChart from 'components/ReportCharts/PracticeBatterSingleSessionSummaryAggregatedChart/PracticeBatterSingleSessionSummaryAggregatedChart';
import PracticeBatterSingleSessionSummaryAggregatedChartSidebar from 'components/ReportCharts/PracticeBatterSingleSessionSummaryAggregatedChart/PracticeBatterSingleSessionSummaryAggregatedChartSidebar';
import PracticeBatterSingleSessionPitchLocationChart from 'components/ReportCharts/PracticeBatterSingleSessionPitchLocationChart/PracticeBatterSingleSessionPitchLocationChart';
import PracticeBatterSingleSessionPitchLocationChartSidebar from 'components/ReportCharts/PracticeBatterSingleSessionPitchLocationChart/PracticeBatterSingleSessionPitchLocationChartSidebar';
import PracticeBatterSingleSessionContactPointChart from 'components/ReportCharts/PracticeBatterSingleSessionContactPointChart/PracticeBatterSingleSessionContactPointChart';
import PracticeBatterSingleSessionContactPointChartSidebar from 'components/ReportCharts/PracticeBatterSingleSessionContactPointChart/PracticeBatterSingleSessionContactPointChartSidebar';
import PracticeBatterSessionSummaryChart from 'components/ReportCharts/PracticeBatterSessionSummaryChart/PracticeBatterSessionSummaryChart';
import PracticeBatterSessionSummaryChartSidebar from 'components/ReportCharts/PracticeBatterSessionSummaryChart/PracticeBatterSessionSummaryChartSidebar';
import ReportTimelineTrendChart from 'components/ReportChartsShared/ReportTimelineTrendChart/ReportTimelineTrendChart';
import ReportTimelineTrendChartSidebar from 'components/ReportChartsShared/ReportTimelineTrendChart/ReportTimelineTrendChartSidebar';
import PracticePitcherSingleSessionPitchTypeUsageChart from 'components/ReportCharts/PracticePitcherSingleSessionPitchTypeUsageChart/PracticePitcherSingleSessionPitchTypeUsageChart';
import PracticePitcherSingleSessionPitchTypeRangesChart from 'components/ReportCharts/PracticePitcherSingleSessionPitchTypeRangesChart/PracticePitcherSingleSessionPitchTypeRangesChart';
import PracticePitcherSingleSessionPitchTypeRangesChartSidebar from 'components/ReportCharts/PracticePitcherSingleSessionPitchTypeRangesChart/PracticePitcherSingleSessionPitchTypeRangesChartSidebar';
import PracticePitcherSingleSessionPitchLocationChart from 'components/ReportCharts/PracticePitcherSingleSessionPitchLocationChart/PracticePitcherSingleSessionPitchLocationChart';
import PracticePitcherSingleSessionPitchLocationChartSidebar from 'components/ReportCharts/PracticePitcherSingleSessionPitchLocationChart/PracticePitcherSingleSessionPitchLocationChartSidebar';
import PracticePitcherSingleSessionStatsByPitchTypeChart from 'components/ReportCharts/PracticePitcherSingleSessionStatsByPitchTypeChart/PracticePitcherSingleSessionStatsByPitchTypeChart';
import PracticePitcherSingleSessionStatsByPitchTypeChartSidebar from 'components/ReportCharts/PracticePitcherSingleSessionStatsByPitchTypeChart/PracticePitcherSingleSessionStatsByPitchTypeChartSidebar';
import PracticePitcherSingleSessionTiltChart from 'components/ReportCharts/PracticePitcherSingleSessionTiltChart/PracticePitcherSingleSessionTiltChart';
import PracticePitcherSingleSessionTiltChartSidebar from 'components/ReportCharts/PracticePitcherSingleSessionTiltChart/PracticePitcherSingleSessionTiltChartSidebar';
import PracticePitcherSingleSessionPitchByPitchStatsChart from 'components/ReportCharts/PracticePitcherSingleSessionPitchByPitchStatsChart/PracticePitcherSingleSessionPitchByPitchStatsChart';
import PracticePitcherSingleSessionPitchByPitchStatsChartSidebar from 'components/ReportCharts/PracticePitcherSingleSessionPitchByPitchStatsChart/PracticePitcherSingleSessionPitchByPitchStatsChartSidebar';
import PracticePitcherSessionPitchTypeRangesChart from 'components/ReportCharts/PracticePitcherSessionPitchTypeRangesChar/PracticePitcherSessionPitchTypeRangesChart';
import PracticePitcherSessionPitchTypeRangesChartSidebar from 'components/ReportCharts/PracticePitcherSessionPitchTypeRangesChar/PracticePitcherSessionPitchTypeRangesChartSidebar';
import PracticePitcherSessionStatsByPitchTypeChart from 'components/ReportCharts/PracticePitcherSessionStatsByPitchTypeChart/PracticePitcherSessionStatsByPitchTypeChart';
import PracticePitcherSessionStatsByPitchTypeChartSidebar from 'components/ReportCharts/PracticePitcherSessionStatsByPitchTypeChart/PracticePitcherSessionStatsByPitchTypeChartSidebar';
import PracticePitcherSessionPitchLocationChart from 'components/ReportCharts/PracticePitcherSessionPitchLocationChart/PracticePitcherSessionPitchLocationChart';
import PracticePitcherSessionPitchLocationChartSidebar from 'components/ReportCharts/PracticePitcherSessionPitchLocationChart/PracticePitcherSessionPitchLocationChartSidebar';
import PracticePitcherSessionTiltChart from 'components/ReportCharts/PracticePitcherSessionTiltChart/PracticePitcherSessionTiltChart';
import PracticePitcherSessionTiltChartSidebar from 'components/ReportCharts/PracticePitcherSessionTiltChart/PracticePitcherSessionTiltChartSidebar';

export type ChartProps<ChartType, Config> = {
  chartData: ChartType | undefined;
  isLoading: boolean;
  chartConfig: ChartConfig<Config>;
  savedChartConfig: ChartConfig<Config>;
};

export type ChartConfigProps<Config, Layout> = {
  chartConfig: ChartConfig<Config>;
  setTempLayout: (newLayout: Layout) => void;
  tempLayout: Layout;
};

type ChartConfig<Config> = Omit<Config, 'chartId' | 'chartDrawingInfo' | 'isHidden'>;

// Ecery report type must have a unique `type REPORT_TYPE_ChartDataKey`, and it must exclude all fields that do not contain `chartId`
// ...ReportResultDto is returend from Generate endpoint call
type PitcherPlayerReportChartDataKey = Exclude<keyof PitcherPlayerReportResultDto['chartData'][number], 'playerName'>;
type BatterPlayerReportChartDataKey = Exclude<keyof BatterPlayerReportResultDto['chartData'][number], 'playerName'>;

type PitcherSessionReportChartDataKey = Exclude<keyof PitcherSessionReportResultDto['chartData'][number], 'playerName'>;
type BatterSessionReportChartDataKey = Exclude<keyof BatterSessionReportResultDto['chartData'][number], 'playerName'>;

type PitcherSingleSessionReportChartDataKey = Exclude<keyof PitcherSingleSessionReportResultDto['chartData'][number], 'playerName'>;
type BatterSingleSessionReportChartDataKey = Exclude<keyof BatterSingleSessionReportResultDto['chartData'][number], 'playerName'>;

type UmpireReportChartDataKey = Exclude<keyof UmpireReportResultDto['chartData'][number], 'umpireName'>;
type UmpireReportForSessionChartDataKey = Exclude<keyof UmpireReportForSessionResultDto['chartData'][number], 'umpireName'>;
type UmpireReportForAdminChartDataKey = Exclude<keyof UmpireReportForAdminResultDto['chartData'][number], 'leagueName'>;

type PracticeBatterSessionReportChartDataKey = Exclude<keyof PracticeBatterSessionReportResultDto['chartData'][number], 'playerName'>;
type PracticeBatterSingleSessionReportChartDataKey = Exclude<
  keyof PracticeBatterSingleSessionReportResultDto['chartData'][number],
  'playerName'
>;
type PracticePitcherSessionReportChartDataKey = Exclude<keyof PracticePitcherSessionReportResultDto['chartData'][number], 'playerName'>;
type PracticePitcherSingleSessionReportChartDataKey = Exclude<
  keyof PracticePitcherSingleSessionReportResultDto['chartData'][number],
  'playerName'
>;

type ExternalPitcherReportChartDataKey = Exclude<keyof ExternalPitcherReportResultDto['chartData'][number], 'playerName'>;
type ExternalBatterReportChartDataKey = Exclude<keyof ExternalBatterReportResultDto['chartData'][number], 'playerName'>;

type ChartDataKey =
  | PitcherPlayerReportChartDataKey
  | BatterPlayerReportChartDataKey
  | PitcherSessionReportChartDataKey
  | BatterSessionReportChartDataKey
  | PitcherSingleSessionReportChartDataKey
  | BatterSingleSessionReportChartDataKey
  | UmpireReportChartDataKey
  | UmpireReportForSessionChartDataKey
  | UmpireReportForAdminChartDataKey
  | PracticeBatterSessionReportChartDataKey
  | PracticeBatterSingleSessionReportChartDataKey
  | PracticePitcherSessionReportChartDataKey
  | PracticePitcherSingleSessionReportChartDataKey
  | ExternalPitcherReportChartDataKey
  | ExternalBatterReportChartDataKey;

type ChartConfigKey =
  | keyof PitcherReportChartConfigDto
  | keyof BatterReportChartConfigDto
  | keyof PitcherSessionReportChartConfigDto
  | keyof PitcherSingleSessionReportChartConfigDto
  | keyof BatterSessionReportChartConfigDto
  | keyof BatterSingleSessionReportChartConfigDto
  | keyof UmpireReportChartConfigDto
  | keyof UmpireReportForSessionChartConfigDto
  | keyof UmpireReportForAdminChartConfigDto
  | keyof PracticeBatterSessionReportChartConfigDto
  | keyof PracticeBatterSingleSessionReportChartConfigDto
  | keyof PracticePitcherSessionReportChartConfigDto
  | keyof PracticePitcherSingleSessionReportChartConfigDto
  | keyof ExternalPitcherReportChartConfigDto
  | keyof ExternalBatterReportChartConfigDto;

type ChartSetup = {
  Chart: any; // `any` here doesn't matter, since the type will be inferred due to `as const`
  dataKey: ChartDataKey;
  configKey: ChartConfigKey;
  Sidebar: any;
};

export const chartIdTochartSetup = {
  // Pitcher player report
  PitchesPerCountChart: {
    Chart: PitchesPerCountChart,
    dataKey: 'pitchesPerCountChartData',
    configKey: 'pitchesPerCountChartConfig',
    Sidebar: undefined,
  },
  PitchTypeStatsChart: {
    Chart: PitchTypeStatsChart,
    dataKey: 'pitchTypeStatsChartData',
    configKey: 'pitchTypeStatsChartConfig',
    Sidebar: PitchTypeStatsChartSidebar,
  },
  PitcherBallTrackingStatsChart: {
    Chart: PitcherBallTrackingStatsChart,
    dataKey: 'ballTrackingStatsChartData',
    configKey: 'pitcherBallTrackingStatsChartConfig',
    Sidebar: PitcherBallTrackingStatsChartSidebar,
  },
  PitcherPercentileRankingsChart: {
    Chart: PercentileRankingsChart,
    dataKey: 'percentileRankingsChartData',
    configKey: 'pitcherPercentileRankingsChartConfig',
    Sidebar: (props: ChartConfigProps<PercentileRankingsChartConfigDto, PitcherReportChartConfigDto>) => (
      <PercentileRankingsChartSidebar
        {...props}
        chartId='PitcherPercentileRankingsChart'
        configKey='pitcherPercentileRankingsChartConfig'
      />
    ),
  },
  PitcherHeatmapChart: {
    Chart: PitcherStrikeZoneHeatmapChart,
    dataKey: 'pitcherHeatmapChartData',
    configKey: 'pitcherHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, PitcherReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar {...props} chartId='PitcherHeatmapChart' configKey='pitcherHeatmapChartConfig' playerType='Pitcher' />
    ),
  },
  PitchingStatsChart: {
    Chart: PitchingStatsChart,
    dataKey: 'pitchingStatsChartData',
    configKey: 'pitchingStatsChartConfig',
    Sidebar: PitchingStatsChartSidebar,
  },
  PitcherScatterChart_1: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherScatterChartData_1',
    configKey: 'pitcherScatterChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherScatterChart_1' configKey='pitcherScatterChartConfig_1' />
    ),
  },
  PitcherScatterChart_2: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherScatterChartData_2',
    configKey: 'pitcherScatterChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherScatterChart_2' configKey='pitcherScatterChartConfig_2' />
    ),
  },
  PitcherScatterChart_3: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherScatterChartData_3',
    configKey: 'pitcherScatterChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherScatterChart_3' configKey='pitcherScatterChartConfig_3' />
    ),
  },

  // Batter player report
  BatterPercentileRankingsChart: {
    Chart: PercentileRankingsChart,
    dataKey: 'batterPercentileRankingsChartData',
    configKey: 'batterPercentileRankingsChartConfig',
    Sidebar: (props: ChartConfigProps<PercentileRankingsChartConfigDto, BatterReportChartConfigDto>) => (
      <PercentileRankingsChartSidebar {...props} chartId='BatterPercentileRankingsChart' configKey='batterPercentileRankingsChartConfig' />
    ),
  },
  BatterSprayChart: {
    Chart: SprayOrSprayZoneChart,
    dataKey: 'batterSprayChartData',
    configKey: 'batterSprayChartConfig',
    Sidebar: (props: ChartConfigProps<SprayOrSprayZoneChartConfigDto, BatterReportChartConfigDto>) => (
      <SprayOrSprayZoneChartSidebar {...props} chartId='BatterSprayChart' configKey='batterSprayChartConfig' />
    ),
  },
  BatterHeatmapChart: {
    Chart: BatterStrikeZoneHeatmapChart,
    dataKey: 'batterHeatmapChartData',
    configKey: 'batterHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, BatterReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar {...props} chartId='BatterHeatmapChart' configKey='batterHeatmapChartConfig' playerType='Batter' />
    ),
  },
  BatterUsedPitchTypesChart: {
    Chart: BatterUsedPitchTypesChart,
    dataKey: 'batterUsedPitchTypesChartData',
    configKey: 'batterUsedPitchTypesChartConfig',
    Sidebar: BatterUsedPitchTypesChartSidebar,
  },
  BatterApproachPerCountChart: {
    Chart: BatterApproachPerCountChart,
    dataKey: 'batterApproachPerCountChartData',
    configKey: 'batterApproachPerCountChartConfig',
    Sidebar: undefined,
  },
  BatterBallStrikeSummaryChart: {
    Chart: BatterBallStrikeSummaryChart,
    dataKey: 'batterBallStrikeSummaryChartData',
    configKey: 'batterBallStrikeSummaryChartConfig',
    Sidebar: BatterBallStrikeSummaryChartSidebar,
  },
  BattingStatsChart: {
    Chart: BatterBattingStatsChart,
    dataKey: 'battingStatsChartData',
    configKey: 'battingStatsChartConfig',
    Sidebar: BattingStatsChartSidebar,
  },

  // Umpire report
  UmpireStrikeZoneChart: {
    Chart: UmpireStrikeZoneChart,
    dataKey: 'umpireStrikeZoneChartData',
    configKey: 'umpireStrikeZoneChartConfig',
    Sidebar: UmpireStrikeZoneChartSidebar,
  },
  UmpireStrikeZoneAccuracyChart: {
    Chart: UmpireStrikeZoneAccuracyChart,
    dataKey: 'umpireStrikeZoneAccuracyChartData',
    configKey: 'umpireStrikeZoneAccuracyChartConfig',
    Sidebar: undefined,
  },
  UmpireGamePerformanceChart: {
    Chart: UmpireGamePerformanceChart,
    dataKey: 'umpireGamePerformanceChartData',
    configKey: 'umpireGamePerformanceChartConfig',
    Sidebar: UmpireGamePerformanceChartSidebar,
  },
  UmpirePitchCallChart: {
    Chart: UmpirePitchCallChart,
    dataKey: 'umpirePitchCallChartData',
    configKey: 'umpirePitchCallChartConfig',
    Sidebar: UmpirePitchCallChartSidebar,
  },
  UmpireTrendsChart: {
    Chart: UmpireTrendsChart,
    dataKey: 'umpireTrendsChartData',
    configKey: 'umpireTrendsChartConfig',
    Sidebar: UmpireTrendsChartSidebar,
  },
  UmpirePerformanceSummaryChart: {
    Chart: UmpirePerformanceSummaryChart,
    dataKey: 'umpirePerformanceSummaryChartData',
    configKey: 'umpireReportPerformanceSummaryChartConfig',
    Sidebar: UmpirePerformanceSummaryChartSidebar,
  },
  UmpireTopAndBottomPerformanceChart: {
    Chart: UmpireTopAndBottomPerformanceChart,
    dataKey: 'umpireTopBottomPerformanceChartData',
    configKey: 'umpireReportTopAndBottomPerformanceChartConfig',
    Sidebar: UmpireTopAndBottomPerformanceChartSidebar,
  },

  // Pitcher session report
  PitcherSessionPitchTypeRangesChart: {
    Chart: PitcherSessionPitchTypeRangesChart,
    dataKey: 'pitcherSessionPitchTypeRangesChartData',
    configKey: 'pitcherSessionPitchTypeRangesChartConfig',
    Sidebar: PitcherSessionPitchTypeRangesChartSidebar,
  },
  PitcherSessionStatsByPitchTypeChart: {
    Chart: PitcherSessionStatsByPitchTypeChart,
    dataKey: 'pitcherSessionStatsByPitchTypeChartData',
    configKey: 'pitcherSessionStatsByPitchTypeChartConfig',
    Sidebar: PitcherSessionStatsByPitchTypeChartSidebar,
  },
  PitcherSessionHeatmapChart: {
    Chart: PitcherStrikeZoneHeatmapChart,
    dataKey: 'pitcherSessionHeatmapChartData',
    configKey: 'pitcherSessionHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar
        {...props}
        chartId='PitcherSessionHeatmapChart'
        configKey='pitcherSessionHeatmapChartConfig'
        playerType='Pitcher'
      />
    ),
  },
  PitcherSessionTiltChart: {
    Chart: PitcherSessionTiltChart,
    dataKey: 'pitcherSessionTiltChartData',
    configKey: 'pitcherSessionTiltChartConfig',
    Sidebar: undefined,
  },
  PitcherSessionScatterChart_1: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSessionScatterChartData_1',
    configKey: 'pitcherSessionScatterChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherSessionScatterChart_1' configKey='pitcherSessionScatterChartConfig_1' />
    ),
  },
  PitcherSessionScatterChart_2: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSessionScatterChartData_2',
    configKey: 'pitcherSessionScatterChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherSessionScatterChart_2' configKey='pitcherSessionScatterChartConfig_2' />
    ),
  },
  PitcherSessionScatterChart_3: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSessionScatterChartData_3',
    configKey: 'pitcherSessionScatterChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherSessionScatterChart_3' configKey='pitcherSessionScatterChartConfig_3' />
    ),
  },
  PitcherSessionTimelineChart_1: {
    Chart: TimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_1',
    configKey: 'pitcherSessionTimelineChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <TimelineChartSidebar {...props} chartId='PitcherSessionTimelineChart_1' configKey='pitcherSessionTimelineChartConfig_1' />
    ),
  },
  PitcherSessionTimelineChart_2: {
    Chart: TimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_2',
    configKey: 'pitcherSessionTimelineChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <TimelineChartSidebar {...props} chartId='PitcherSessionTimelineChart_2' configKey='pitcherSessionTimelineChartConfig_2' />
    ),
  },
  PitcherSessionTimelineChart_3: {
    Chart: TimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_3',
    configKey: 'pitcherSessionTimelineChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <TimelineChartSidebar {...props} chartId='PitcherSessionTimelineChart_3' configKey='pitcherSessionTimelineChartConfig_3' />
    ),
  },
  PitcherSessionTimelineChart_4: {
    Chart: TimelineChart,
    dataKey: 'pitcherSessionTimelineChartData_4',
    configKey: 'pitcherSessionTimelineChartConfig_4',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSessionReportChartConfigDto>) => (
      <TimelineChartSidebar {...props} chartId='PitcherSessionTimelineChart_4' configKey='pitcherSessionTimelineChartConfig_4' />
    ),
  },
  PitcherSessionPitchLocationChart: {
    Chart: PitcherSessionPitchLocationChart,
    dataKey: 'pitcherSessionPitchLocationChartData',
    configKey: 'pitcherSessionPitchLocationChartConfig',
    Sidebar: PitcherSessionPitchLocationChartSidebar,
  },

  // Pitcher single session report
  PitcherSingleSessionPitchTypeUsageChart: {
    Chart: PitcherSingleSessionPitchTypeUsageChart,
    dataKey: 'pitcherSingleSessionPitchTypeUsageChartData',
    configKey: 'pitcherSingleSessionPitchTypeUsageChartConfig',
    Sidebar: undefined,
  },
  PitcherSingleSessionPitchTypeRangesChart: {
    Chart: PitcherSingleSessionPitchTypeRangesChart,
    dataKey: 'pitcherSingleSessionPitchTypeRangesChartData',
    configKey: 'pitcherSingleSessionPitchTypeRangesChartConfig',
    Sidebar: PitcherSingleSessionPitchTypeRangesChartSidebar,
  },
  PitcherSingleSessionStatsByPitchTypeChart: {
    Chart: PitcherSingleSessionStatsByPitchTypeChart,
    dataKey: 'pitcherSingleSessionStatsByPitchTypeChartData',
    configKey: 'pitcherSingleSessionStatsByPitchTypeChartConfig',
    Sidebar: PitcherSingleSessionStatsByPitchTypeChartSidebar,
  },
  PitcherSingleSessionHeatmapChart: {
    Chart: PitcherStrikeZoneHeatmapChart,
    dataKey: 'pitcherSingleSessionHeatmapChartData',
    configKey: 'pitcherSingleSessionHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar
        {...props}
        chartId='PitcherSingleSessionHeatmapChart'
        configKey='pitcherSingleSessionHeatmapChartConfig'
        playerType='Pitcher'
      />
    ),
  },
  PitcherSingleSessionScatterChart_1: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_1',
    configKey: 'pitcherSingleSessionScatterChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PitcherSingleSessionScatterChart_1'
        configKey='pitcherSingleSessionScatterChartConfig_1'
      />
    ),
  },
  PitcherSingleSessionScatterChart_2: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_2',
    configKey: 'pitcherSingleSessionScatterChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PitcherSingleSessionScatterChart_2'
        configKey='pitcherSingleSessionScatterChartConfig_2'
      />
    ),
  },
  PitcherSingleSessionScatterChart_3: {
    Chart: ReportScatterChart,
    dataKey: 'pitcherSingleSessionScatterChartData_3',
    configKey: 'pitcherSingleSessionScatterChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PitcherSingleSessionScatterChart_3'
        configKey='pitcherSingleSessionScatterChartConfig_3'
      />
    ),
  },
  PitcherSingleSessionPitchByPitchStatsChart: {
    Chart: PitcherSingleSessionPitchByPitchStatsChart,
    dataKey: 'pitcherSingleSessionPitchByPitchStatsChartData',
    configKey: 'pitcherSingleSessionPitchByPitchStatsChartConfig',
    Sidebar: PitcherSingleSessionPitchByPitchStatsChartSidebar,
  },
  PitcherSingleSessionGameStatsChart: {
    Chart: PitcherSingleSessionGameStatsChart,
    dataKey: 'pitcherSingleSessionGameStatsChartData',
    configKey: 'pitcherSingleSessionGameStatsChartConfig',
    Sidebar: PitcherSingleSessionGameStatsChartSidebar,
  },
  PitcherSingleSessionPitchLocationChart: {
    Chart: PitcherSingleSessionPitchLocationChart,
    dataKey: 'pitcherSingleSessionPitchLocationChartData',
    configKey: 'pitcherSingleSessionPitchLocationChartConfig',
    Sidebar: PitcherSingleSessionPitchLocationChartSidebar,
  },
  PitcherSingleSessionPitchByPitchLineChart_1: {
    Chart: ReportLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_1',
    configKey: 'pitcherSingleSessionPitchByPitchLineChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PitcherSingleSessionPitchByPitchLineChart_1'
        configKey='pitcherSingleSessionPitchByPitchLineChartConfig_1'
      />
    ),
  },
  PitcherSingleSessionPitchByPitchLineChart_2: {
    Chart: ReportLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_2',
    configKey: 'pitcherSingleSessionPitchByPitchLineChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PitcherSingleSessionPitchByPitchLineChart_2'
        configKey='pitcherSingleSessionPitchByPitchLineChartConfig_2'
      />
    ),
  },
  PitcherSingleSessionPitchByPitchLineChart_3: {
    Chart: ReportLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_3',
    configKey: 'pitcherSingleSessionPitchByPitchLineChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PitcherSingleSessionPitchByPitchLineChart_3'
        configKey='pitcherSingleSessionPitchByPitchLineChartConfig_3'
      />
    ),
  },
  PitcherSingleSessionPitchByPitchLineChart_4: {
    Chart: ReportLineChart,
    dataKey: 'pitcherSingleSessionPitchByPitchLineChartData_4',
    configKey: 'pitcherSingleSessionPitchByPitchLineChartConfig_4',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PitcherSingleSessionPitchByPitchLineChart_4'
        configKey='pitcherSingleSessionPitchByPitchLineChartConfig_4'
      />
    ),
  },

  // Batter session report
  BatterSessionHeatmapChart: {
    Chart: BatterStrikeZoneHeatmapChart,
    dataKey: 'batterSessionHeatmapChartData',
    configKey: 'batterSessionHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar
        {...props}
        chartId='BatterSessionHeatmapChart'
        configKey='batterSessionHeatmapChartConfig'
        playerType='Batter'
      />
    ),
  },
  BatterSessionSprayChart: {
    Chart: SprayOrSprayZoneChart,
    dataKey: 'batterSessionSprayChartData',
    configKey: 'batterSessionSprayChartConfig',
    Sidebar: (props: ChartConfigProps<SprayOrSprayZoneChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <SprayOrSprayZoneChartSidebar {...props} chartId='BatterSessionSprayChart' configKey='batterSessionSprayChartConfig' />
    ),
  },
  BatterSessionStatsByPitchTypeChart: {
    Chart: BatterSessionStatsByPitchTypeChart,
    dataKey: 'batterSessionStatsByPitchTypeChartData',
    configKey: 'batterSessionStatsByPitchTypeChartConfig',
    Sidebar: BatterSessionStatsByPitchTypeChartSidebar,
  },
  BatterSessionTimelineChart_1: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'batterSessionTimelineChartData_1',
    configKey: 'batterSessionTimelineChartConfig_1',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar chartId='BatterSessionTimelineChart_1' configKey='batterSessionTimelineChartConfig_1' {...props} />
    ),
  },
  BatterSessionTimelineChart_2: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'batterSessionTimelineChartData_2',
    configKey: 'batterSessionTimelineChartConfig_2',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar chartId='BatterSessionTimelineChart_2' configKey='batterSessionTimelineChartConfig_2' {...props} />
    ),
  },
  BatterSessionTimelineChart_3: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'batterSessionTimelineChartData_3',
    configKey: 'batterSessionTimelineChartConfig_3',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar chartId='BatterSessionTimelineChart_3' configKey='batterSessionTimelineChartConfig_3' {...props} />
    ),
  },
  BatterSessionTimelineChart_4: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'batterSessionTimelineChartData_4',
    configKey: 'batterSessionTimelineChartConfig_4',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar chartId='BatterSessionTimelineChart_4' configKey='batterSessionTimelineChartConfig_4' {...props} />
    ),
  },

  // Batter single session report
  BatterSingleSessionPitchLocationChart: {
    Chart: BatterSingleSessionPitchLocationChart,
    dataKey: 'batterSingleSessionPitchLocationChartData',
    configKey: 'batterSingleSessionPitchLocationChartConfig',
    Sidebar: BatterSingleSessionPitchLocationChartSidebar,
  },
  BatterSingleSessionContactPointChart: {
    Chart: BatterSingleSessionContactPointChart,
    dataKey: 'batterSingleSessionContactPointChartData',
    configKey: 'batterSingleSessionContactPointChartConfig',
    Sidebar: undefined,
  },
  BatterSingleSessionGameStatsChart: {
    Chart: BatterSingleSessionGameStatsChart,
    dataKey: 'batterSingleSessionGameStatsChartData',
    configKey: 'batterSingleSessionGameStatsChartConfig',
    Sidebar: BatterSingleSessionGameStatsChartSidebar,
  },
  BatterSingleSessionPitchByPitchStatsChart: {
    Chart: BatterSingleSessionPitchByPitchStatsChart,
    dataKey: 'batterSingleSessionPitchByPitchStatsChartData',
    configKey: 'batterSingleSessionPitchByPitchStatsChartConfig',
    Sidebar: BatterSingleSessionPitchByPitchStatsChartSidebar,
  },
  BatterSingleSessionBattingStatChart_1: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_1',
    configKey: 'batterSingleSessionBattingStatChartConfig_1',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_1'
        chartId='BatterSingleSessionBattingStatChart_1'
        {...props}
      />
    ),
  },
  BatterSingleSessionBattingStatChart_2: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_2',
    configKey: 'batterSingleSessionBattingStatChartConfig_2',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_2'
        chartId='BatterSingleSessionBattingStatChart_2'
        {...props}
      />
    ),
  },
  BatterSingleSessionBattingStatChart_3: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_3',
    configKey: 'batterSingleSessionBattingStatChartConfig_3',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_3'
        chartId='BatterSingleSessionBattingStatChart_3'
        {...props}
      />
    ),
  },
  BatterSingleSessionBattingStatChart_4: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_4',
    configKey: 'batterSingleSessionBattingStatChartConfig_4',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_4'
        chartId='BatterSingleSessionBattingStatChart_4'
        {...props}
      />
    ),
  },
  BatterSingleSessionBattingStatChart_5: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_5',
    configKey: 'batterSingleSessionBattingStatChartConfig_5',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_5'
        chartId='BatterSingleSessionBattingStatChart_5'
        {...props}
      />
    ),
  },
  BatterSingleSessionBattingStatChart_6: {
    Chart: BattingStatChart,
    dataKey: 'batterSingleSessionBattingStatChartData_6',
    configKey: 'batterSingleSessionBattingStatChartConfig_6',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, BatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='batterSingleSessionBattingStatChartConfig_6'
        chartId='BatterSingleSessionBattingStatChart_6'
        {...props}
      />
    ),
  },

  // Practice batter session report
  PracticeBatterSessionHeatmapChart: {
    Chart: BatterStrikeZoneHeatmapChart,
    dataKey: 'practiceBatterSessionHeatmapChartData',
    configKey: 'practiceBatterSessionHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar
        {...props}
        chartId='PracticeBatterSessionHeatmapChart'
        configKey='practiceBatterSessionHeatmapChartConfig'
        playerType='Batter'
      />
    ),
  },
  PracticeBatterSessionSprayChart: {
    Chart: SprayOrSprayZoneChart,
    dataKey: 'practiceBatterSessionSprayChartData',
    configKey: 'practiceBatterSessionSprayChartConfig',
    Sidebar: (props: ChartConfigProps<SprayOrSprayZoneChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <SprayOrSprayZoneChartSidebar
        {...props}
        chartId='PracticeBatterSessionSprayChart'
        configKey='practiceBatterSessionSprayChartConfig'
      />
    ),
  },
  PracticeBatterSessionScatterChart_1: {
    Chart: ReportScatterChart,
    dataKey: 'practiceBatterSessionScatterChartData_1',
    configKey: 'practiceBatterSessionScatterChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PracticeBatterSessionScatterChart_1'
        configKey='practiceBatterSessionScatterChartConfig_1'
      />
    ),
  },
  PracticeBatterSessionScatterChart_2: {
    Chart: ReportScatterChart,
    dataKey: 'practiceBatterSessionScatterChartData_2',
    configKey: 'practiceBatterSessionScatterChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PracticeBatterSessionScatterChart_2'
        configKey='practiceBatterSessionScatterChartConfig_2'
      />
    ),
  },
  PracticeBatterSessionSummaryChart: {
    Chart: PracticeBatterSessionSummaryChart,
    dataKey: 'practiceBatterSessionSummaryChartData',
    configKey: 'practiceBatterSessionSummaryChartConfig',
    Sidebar: PracticeBatterSessionSummaryChartSidebar,
  },
  PracticeBatterSessionTimelineChart_1: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'practiceBatterSessionTimelineChartData_1',
    configKey: 'practiceBatterSessionTimelineChartConfig_1',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar
        chartId='PracticeBatterSessionTimelineChart_1'
        configKey='practiceBatterSessionTimelineChartConfig_1'
        {...props}
      />
    ),
  },
  PracticeBatterSessionTimelineChart_2: {
    Chart: ReportTimelineTrendChart,
    dataKey: 'practiceBatterSessionTimelineChartData_2',
    configKey: 'practiceBatterSessionTimelineChartConfig_2',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <ReportTimelineTrendChartSidebar
        chartId='PracticeBatterSessionTimelineChart_2'
        configKey='practiceBatterSessionTimelineChartConfig_2'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_1: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_1',
    configKey: 'practiceBatterSessionBattingStatChartConfig_1',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_1'
        chartId='PracticeBatterSessionBattingStatChart_1'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_2: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_2',
    configKey: 'practiceBatterSessionBattingStatChartConfig_2',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_2'
        chartId='PracticeBatterSessionBattingStatChart_2'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_3: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_3',
    configKey: 'practiceBatterSessionBattingStatChartConfig_3',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_3'
        chartId='PracticeBatterSessionBattingStatChart_3'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_4: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_4',
    configKey: 'practiceBatterSessionBattingStatChartConfig_4',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_4'
        chartId='PracticeBatterSessionBattingStatChart_4'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_5: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_5',
    configKey: 'practiceBatterSessionBattingStatChartConfig_5',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_5'
        chartId='PracticeBatterSessionBattingStatChart_5'
        {...props}
      />
    ),
  },
  PracticeBatterSessionBattingStatChart_6: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSessionBattingStatChartData_6',
    configKey: 'practiceBatterSessionBattingStatChartConfig_6',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSessionBattingStatChartConfig_6'
        chartId='PracticeBatterSessionBattingStatChart_6'
        {...props}
      />
    ),
  },

  // Practice batter single session report
  PracticeBatterSingleSessionPitchLocationChart: {
    Chart: PracticeBatterSingleSessionPitchLocationChart,
    dataKey: 'practiceBatterSingleSessionPitchLocationChartData',
    configKey: 'practiceBatterSingleSessionPitchLocationChartConfig',
    Sidebar: PracticeBatterSingleSessionPitchLocationChartSidebar,
  },
  PracticeBatterSingleSessionContactPointChart: {
    Chart: PracticeBatterSingleSessionContactPointChart,
    dataKey: 'practiceBatterSingleSessionContactPointChartData',
    configKey: 'practiceBatterSingleSessionContactPointChartConfig',
    Sidebar: PracticeBatterSingleSessionContactPointChartSidebar,
  },
  PracticeBatterSingleSessionSummaryChart: {
    Chart: PracticeBatterSingleSessionSummaryChart,
    dataKey: 'practiceBatterSingleSessionSummaryChartData',
    configKey: 'practiceBatterSingleSessionSummaryChartConfig',
    Sidebar: PracticeBatterSingleSessionSummaryChartSidebar,
  },
  PracticeBatterSingleSessionSummaryAggregatedChart: {
    Chart: PracticeBatterSingleSessionSummaryAggregatedChart,
    dataKey: 'practiceBatterSingleSessionSummaryAggregatedChartData',
    configKey: 'practiceBatterSingleSessionSummaryAggregatedChartConfig',
    Sidebar: PracticeBatterSingleSessionSummaryAggregatedChartSidebar,
  },
  PracticeBatterSingleSessionBattingStatChart_1: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_1',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_1',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_1'
        chartId='PracticeBatterSingleSessionBattingStatChart_1'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionBattingStatChart_2: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_2',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_2',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_2'
        chartId='PracticeBatterSingleSessionBattingStatChart_2'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionBattingStatChart_3: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_3',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_3',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_3'
        chartId='PracticeBatterSingleSessionBattingStatChart_3'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionBattingStatChart_4: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_4',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_4',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_4'
        chartId='PracticeBatterSingleSessionBattingStatChart_4'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionBattingStatChart_5: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_5',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_5',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_5'
        chartId='PracticeBatterSingleSessionBattingStatChart_5'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionBattingStatChart_6: {
    Chart: BattingStatChart,
    dataKey: 'practiceBatterSingleSessionBattingStatChartData_6',
    configKey: 'practiceBatterSingleSessionBattingStatChartConfig_6',
    Sidebar: (props: ChartConfigProps<PlayerStatChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <BattingStatChartSidebar
        configKey='practiceBatterSingleSessionBattingStatChartConfig_6'
        chartId='PracticeBatterSingleSessionBattingStatChart_6'
        {...props}
      />
    ),
  },
  PracticeBatterSingleSessionPitchByPitchLineChart_1: {
    Chart: ReportLineChart,
    dataKey: 'practiceBatterSingleSessionPitchByPitchLineChartData_1',
    configKey: 'practiceBatterSingleSessionPitchByPitchLineChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticeBatterSingleSessionPitchByPitchLineChart_1'
        configKey='practiceBatterSingleSessionPitchByPitchLineChartConfig_1'
      />
    ),
  },
  PracticeBatterSingleSessionPitchByPitchLineChart_2: {
    Chart: ReportLineChart,
    dataKey: 'practiceBatterSingleSessionPitchByPitchLineChartData_2',
    configKey: 'practiceBatterSingleSessionPitchByPitchLineChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticeBatterSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticeBatterSingleSessionPitchByPitchLineChart_2'
        configKey='practiceBatterSingleSessionPitchByPitchLineChartConfig_2'
      />
    ),
  },

  // Practice pitcher session report
  PracticePitcherSessionPitchTypeRangesChart: {
    Chart: PracticePitcherSessionPitchTypeRangesChart,
    dataKey: 'practicePitcherSessionPitchTypeRangesChartData',
    configKey: 'practicePitcherSessionPitchTypeRangesChartConfig',
    Sidebar: PracticePitcherSessionPitchTypeRangesChartSidebar,
  },
  PracticePitcherSessionHeatmapChart: {
    Chart: PitcherStrikeZoneHeatmapChart,
    dataKey: 'practicePitcherSessionHeatmapChartData',
    configKey: 'practicePitcherSessionHeatmapChartConfig',
    Sidebar: (props: ChartConfigProps<HeatmapChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <StrikeZoneHeatmapChartSidebar
        {...props}
        chartId='PracticePitcherSessionHeatmapChart'
        configKey='practicePitcherSessionHeatmapChartConfig'
        playerType='Pitcher'
      />
    ),
  },
  PracticePitcherSessionScatterChart: {
    Chart: ReportScatterChart,
    dataKey: 'practicePitcherSessionScatterChartData',
    configKey: 'practicePitcherSessionScatterChartConfig',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar {...props} chartId='PitcherScatterChart_1' configKey='practicePitcherSessionScatterChartConfig' />
    ),
  },
  PracticePitcherSessionStatsByPitchTypeChart: {
    Chart: PracticePitcherSessionStatsByPitchTypeChart,
    dataKey: 'practicePitcherSessionStatsByPitchTypeChartData',
    configKey: 'practicePitcherSessionStatsByPitchTypeChartConfig',
    Sidebar: PracticePitcherSessionStatsByPitchTypeChartSidebar,
  },
  PracticePitcherSessionPitchByPitchLineChart_1: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSessionPitchByPitchLineChartData_1',
    configKey: 'practicePitcherSessionPitchByPitchLineChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSessionPitchByPitchLineChart_1'
        configKey='practicePitcherSessionPitchByPitchLineChartConfig_1'
      />
    ),
  },
  PracticePitcherSessionPitchByPitchLineChart_2: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSessionPitchByPitchLineChartData_2',
    configKey: 'practicePitcherSessionPitchByPitchLineChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSessionPitchByPitchLineChart_2'
        configKey='practicePitcherSessionPitchByPitchLineChartConfig_2'
      />
    ),
  },
  PracticePitcherSessionPitchByPitchLineChart_3: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSessionPitchByPitchLineChartData_3',
    configKey: 'practicePitcherSessionPitchByPitchLineChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSessionPitchByPitchLineChart_3'
        configKey='practicePitcherSessionPitchByPitchLineChartConfig_3'
      />
    ),
  },
  PracticePitcherSessionPitchByPitchLineChart_4: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSessionPitchByPitchLineChartData_4',
    configKey: 'practicePitcherSessionPitchByPitchLineChartConfig_4',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSessionPitchByPitchLineChart_4'
        configKey='practicePitcherSessionPitchByPitchLineChartConfig_4'
      />
    ),
  },
  PracticePitcherSessionPitchLocationChart: {
    Chart: PracticePitcherSessionPitchLocationChart,
    dataKey: 'practicePitcherSessionPitchLocationChartData',
    configKey: 'practicePitcherSessionPitchLocationChartConfig',
    Sidebar: PracticePitcherSessionPitchLocationChartSidebar,
  },
  PracticePitcherSessionTiltChart_1: {
    Chart: PracticePitcherSessionTiltChart,
    dataKey: 'practicePitcherSessionTiltChartData_1',
    configKey: 'practicePitcherSessionTiltChartConfig_1',
    Sidebar: (props) => (
      <PracticePitcherSessionTiltChartSidebar
        {...props}
        chartId={'PracticePitcherSessionTiltChart_1'}
        configKey='PracticePitcherSessionTiltChartConfig_1'
      />
    ),
  },
  PracticePitcherSessionTiltChart_2: {
    Chart: PracticePitcherSessionTiltChart,
    dataKey: 'practicePitcherSessionTiltChartData_2',
    configKey: 'practicePitcherSessionTiltChartConfig_2',
    Sidebar: (props) => (
      <PracticePitcherSessionTiltChartSidebar
        {...props}
        chartId={'PracticePitcherSessionTiltChart_2'}
        configKey='PracticePitcherSessionTiltChartConfig_2'
      />
    ),
  },

  // Practice pitcher single session report
  PracticePitcherSingleSessionPitchTypeUsageChart: {
    Chart: PracticePitcherSingleSessionPitchTypeUsageChart,
    dataKey: 'practicePitcherSingleSessionPitchTypeUsageChartData',
    configKey: 'practicePitcherSingleSessionPitchTypeUsageChartConfig',
    Sidebar: undefined,
  },
  PracticePitcherSingleSessionPitchTypeRangesChart: {
    Chart: PracticePitcherSingleSessionPitchTypeRangesChart,
    dataKey: 'practicePitcherSingleSessionPitchTypeRangesChartData',
    configKey: 'practicePitcherSingleSessionPitchTypeRangesChartConfig',
    Sidebar: PracticePitcherSingleSessionPitchTypeRangesChartSidebar,
  },
  PracticePitcherSingleSessionScatterChart: {
    Chart: ReportScatterChart,
    dataKey: 'practicePitcherSingleSessionScatterChartData',
    configKey: 'practicePitcherSingleSessionScatterChartConfig',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => (
      <ReportScatterChartSidebar
        {...props}
        chartId='PracticePitcherSingleSessionScatterChart'
        configKey='practicePitcherSingleSessionScatterChartConfig'
      />
    ),
  },
  PracticePitcherSingleSessionPitchLocationChart: {
    Chart: PracticePitcherSingleSessionPitchLocationChart,
    dataKey: 'practicePitcherSingleSessionPitchLocationChartData',
    configKey: 'practicePitcherSingleSessionPitchLocationChartConfig',
    Sidebar: PracticePitcherSingleSessionPitchLocationChartSidebar,
  },
  PracticePitcherSingleSessionStatsByPitchTypeChart: {
    Chart: PracticePitcherSingleSessionStatsByPitchTypeChart,
    dataKey: 'practicePitcherSingleSessionStatsByPitchTypeChartData',
    configKey: 'practicePitcherSingleSessionStatsByPitchTypeChartConfig',
    Sidebar: PracticePitcherSingleSessionStatsByPitchTypeChartSidebar,
  },
  PracticePitcherSingleSessionPitchByPitchLineChart_1: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSingleSessionPitchByPitchLineChartData_1',
    configKey: 'practicePitcherSingleSessionPitchByPitchLineChartConfig_1',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSingleSessionPitchByPitchLineChart_1'
        configKey='practicePitcherSingleSessionPitchByPitchLineChartConfig_1'
      />
    ),
  },
  PracticePitcherSingleSessionPitchByPitchLineChart_2: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSingleSessionPitchByPitchLineChartData_2',
    configKey: 'practicePitcherSingleSessionPitchByPitchLineChartConfig_2',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSingleSessionPitchByPitchLineChart_2'
        configKey='practicePitcherSingleSessionPitchByPitchLineChartConfig_2'
      />
    ),
  },
  PracticePitcherSingleSessionPitchByPitchLineChart_3: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSingleSessionPitchByPitchLineChartData_3',
    configKey: 'practicePitcherSingleSessionPitchByPitchLineChartConfig_3',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSingleSessionPitchByPitchLineChart_3'
        configKey='practicePitcherSingleSessionPitchByPitchLineChartConfig_3'
      />
    ),
  },
  PracticePitcherSingleSessionPitchByPitchLineChart_4: {
    Chart: ReportLineChart,
    dataKey: 'practicePitcherSingleSessionPitchByPitchLineChartData_4',
    configKey: 'practicePitcherSingleSessionPitchByPitchLineChartConfig_4',
    Sidebar: (props: ChartConfigProps<GraphChartConfigDto, PracticePitcherSingleSessionReportChartConfigDto>) => (
      <ReportLineChartSidebar
        {...props}
        chartId='PracticePitcherSingleSessionPitchByPitchLineChart_4'
        configKey='practicePitcherSingleSessionPitchByPitchLineChartConfig_4'
      />
    ),
  },
  PracticePitcherSingleSessionTiltChart_1: {
    Chart: PracticePitcherSingleSessionTiltChart,
    dataKey: 'practicePitcherSingleSessionTiltChartData_1',
    configKey: 'practicePitcherSingleSessionTiltChartConfig_1',
    Sidebar: (props) => (
      <PracticePitcherSingleSessionTiltChartSidebar
        {...props}
        chartId={'PracticePitcherSingleSessionTiltChart_1'}
        configKey='PracticePitcherSingleSessionTiltChartConfig_1'
      />
    ),
  },
  PracticePitcherSingleSessionTiltChart_2: {
    Chart: PracticePitcherSingleSessionTiltChart,
    dataKey: 'practicePitcherSingleSessionTiltChartData_2',
    configKey: 'practicePitcherSingleSessionTiltChartConfig_2',
    Sidebar: (props) => (
      <PracticePitcherSingleSessionTiltChartSidebar
        {...props}
        chartId={'PracticePitcherSingleSessionTiltChart_2'}
        configKey='PracticePitcherSingleSessionTiltChartConfig_2'
      />
    ),
  },
  PracticePitcherSingleSessionPitchByPitchStatsChart: {
    Chart: PracticePitcherSingleSessionPitchByPitchStatsChart,
    dataKey: 'practicePitcherSingleSessionPitchByPitchStatsChartData',
    configKey: 'practicePitcherSingleSessionPitchByPitchStatsChartConfig',
    Sidebar: PracticePitcherSingleSessionPitchByPitchStatsChartSidebar,
  },

  // External pitcher report
  ExternalPitcherPitchTypeUsageChart: {
    Chart: () => <h1>External Pitcher Pitch Type Usage Chart</h1>,
    dataKey: 'externalPitcherPitchTypeUsageChartData',
    configKey: 'externalPitcherPitchTypeUsageChartConfig',
    Sidebar: undefined,
  },
  ExternalPitcherPitchTypeRangesChart: {
    Chart: () => <h1>External Pitcher Pitch Type Ranges Chart</h1>,
    dataKey: 'externalPitcherPitchTypeRangesChartData',
    configKey: 'externalPitcherPitchTypeRangesChartConfig',
    Sidebar: undefined,
  },
  ExternalPitcherScatterChart: {
    Chart: () => <h1>External Pitcher Scatter Chart</h1>,
    dataKey: 'externalPitcherScatterChartData',
    configKey: 'externalPitcherScatterChartConfig',
    Sidebar: undefined,
  },
  ExternalPitcherPitchLocationChart: {
    Chart: () => <h1>External Pitcher Pitch Location Chart</h1>,
    dataKey: 'externalPitcherPitchLocationChartData',
    configKey: 'externalPitcherPitchLocationChartConfig',
    Sidebar: undefined,
  },
  ExternalPitcherStatsByPitchTypeChart: {
    Chart: () => <h1>External Pitcher Stats By Pitch Type Chart</h1>,
    dataKey: 'externalPitcherStatsByPitchTypeChartData',
    configKey: 'externalPitcherStatsByPitchTypeChartConfig',
    Sidebar: undefined,
  },
  ExternalPitcherLineChart_1: {
    Chart: () => <h1>External Pitcher Line Chart 1</h1>,
    dataKey: 'externalPitcherLineChartData_1',
    configKey: 'externalPitcherLineChartConfig_1',
    Sidebar: undefined,
  },
  ExternalPitcherLineChart_2: {
    Chart: () => <h1>External Pitcher Line Chart 2</h1>,
    dataKey: 'externalPitcherLineChartData_2',
    configKey: 'externalPitcherLineChartConfig_2',
    Sidebar: undefined,
  },

  // External batter report
  ExternalBatterHeatmapChart: {
    Chart: () => <h1>External Batter Heatmap Chart</h1>,
    dataKey: 'externalBatterHeatmapChartData',
    configKey: 'externalBatterHeatmapChartConfig',
    Sidebar: undefined,
  },
  ExternalBatterSprayChart: {
    Chart: () => <h1>External Batter Spray Chart</h1>,
    dataKey: 'externalBatterSprayChartData',
    configKey: 'externalBatterSprayChartConfig',
    Sidebar: undefined,
  },
  ExternalBatterScatterChart: {
    Chart: () => <h1>External Batter Scatter Chart</h1>,
    dataKey: 'externalBatterScatterChartData',
    configKey: 'externalBatterScatterChartConfig',
    Sidebar: undefined,
  },
  ExternalBatterStatsByHitTypeChart: {
    Chart: () => <h1>External Batter Stats By Hit Type Chart</h1>,
    dataKey: 'externalBatterStatsByHitTypeChartData',
    configKey: 'externalBatterStatsByHitTypeChartConfig',
    Sidebar: undefined,
  },
  ExternalBatterBattingStatChart_1: {
    Chart: () => <h1>External Batter Batting Stat Chart 1</h1>,
    dataKey: 'externalBatterBattingStatChartData_1',
    configKey: 'externalBatterBattingStatChartConfig_1',
    Sidebar: undefined,
  },
  ExternalBatterBattingStatChart_2: {
    Chart: () => <h1>External Batter Batting Stat Chart 2</h1>,
    dataKey: 'externalBatterBattingStatChartData_2',
    configKey: 'externalBatterBattingStatChartConfig_2',
    Sidebar: undefined,
  },
  ExternalBatterBattingStatChart_3: {
    Chart: () => <h1>External Batter Batting Stat Chart 3</h1>,
    dataKey: 'externalBatterBattingStatChartData_3',
    configKey: 'externalBatterBattingStatChartConfig_3',
    Sidebar: undefined,
  },
  ExternalBatterLineChart_1: {
    Chart: () => <h1>External Batter Line Chart 1</h1>,
    dataKey: 'externalBatterLineChartData_1',
    configKey: 'externalBatterLineChartConfig_1',
    Sidebar: undefined,
  },
  ExternalBatterLineChart_2: {
    Chart: () => <h1>External Batter Line Chart 2</h1>,
    dataKey: 'externalBatterLineChartData_2',
    configKey: 'externalBatterLineChartConfig_2',
    Sidebar: undefined,
  },
} as const satisfies Record<ChartType, ChartSetup>;
